import { init, handleErrorWithSentry } from '@sentry/sveltekit';

init({
  dsn: 'https://a70d018acfb5db38f98e98e68304355a@o4506685238542336.ingest.sentry.io/4506685239918592',
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  integrations: [],
  enabled: true,
});

export const handleError = handleErrorWithSentry(({ error }: { error: unknown }) => {
  console.error(error);
});
